import angular from "angular";
import Vue from "vue";
import "ngVue";
import DriveImportWizard from "./DriveImportWizard.vue";
import DriveColumnMapper from "./DriveColumnMapper.vue";
import DriveFileUploader from "./DriveFileUploader.vue";
import DriveImportPreview from "./DriveImportPreview.vue";
import DriveImportResults from "./DriveImportResults.vue";
import DriveMappingLoadModal from "./DriveMappingLoadModal.vue";
import DriveMappingSaveModal from "./DriveMappingSaveModal.vue";

export {
  DriveImportWizard,
  DriveColumnMapper,
  DriveFileUploader,
  DriveImportPreview,
  DriveImportResults,
  DriveMappingLoadModal,
  DriveMappingSaveModal,
};

export default angular
  .module("admin.directives.driveimport", [])
  .directive("dcDriveImportWizard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcDriveImportWizard", DriveImportWizard));
    },
  ]);
